// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CatalogController from "./catalog_controller"
application.register("catalog", CatalogController)

import LinechartController from "./linechart_controller"
application.register("linechart", LinechartController)
